import { useRouter } from 'next/router';
import { AppLocale } from '../lib/types';

export const DEFAULT_LOCALE: AppLocale = 'ru';

export const useLocale = () => {
    const router = useRouter();
    return (router.locale || DEFAULT_LOCALE) as AppLocale;
};
